import styled from 'styled-components';

import { GRADIENTS, HOME, HOME_MID } from '../../../../theme/tokens';
import { hoverWash } from '../../../../theme/mixins';

/** The inner translucent panel — split stats on the left, trend chart on the
 *  right (`$wide`: a third stat, the website visits, so the stats get more room).
 *  Collapses to one column at 900px. */
export const Inner = styled.div<{ $wide?: boolean }>`
  background: ${HOME.panel};
  border-radius: 16px;
  padding: 12px;
  display: grid;
  grid-template-columns: ${(p) => (p.$wide ? 'minmax(220px, 1.35fr) 1.5fr' : 'minmax(220px, 0.95fr) 1.5fr')};
  gap: 24px;
  align-items: center;

  > * {
    min-width: 0;
  }

  ${HOME_MID} {
    grid-template-columns: 1fr;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
`;

/** One stat as one click target (label, figure, delta and caption) into its Stats view, with the studio's
 *  clickable-card hover. The inset padding gives the wash room around the stat; the equal negative margin keeps the
 *  stat aligned with its neighbours. */
export const StatLink = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  margin: -8px -10px;
  padding: 8px 10px;
  border-radius: 12px;
  cursor: pointer;
  outline: none;
  ${hoverWash}
`;

export const VDivider = styled.div`
  width: 1px;
  align-self: stretch;
  margin: 0 18px;
  background: ${GRADIENTS.dividerStyledV};
`;

export const ChartCol = styled.div`
  min-width: 0;
`;

export const LegendWrap = styled.div`
  margin-top: 10px;
`;
